import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import {
  connect, useDispatch,
} from 'react-redux';
import {
  CommonButton, CommonSearch, CommonSelect, ScreenContainer,
} from '../../CommonComponents';
import {
  getEstimates, getCompanies, getClientsByCompanyCode, getProductsByClientId, getAllCities, getAllStates, getSuppliersByCompany, getROByClient, ataFetchReport,
} from '../../redux/actions/common';
import { showToast } from '../../Utils';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AtaReports = ({
  fetchCompanies,
  fetchClients,
  fetchProducts,
  fetchEstimates,
  clients,
  companies,
  estimates,
  productFilter,
  getCities,
  getStates,
  cities,
  states,
  ro: roNos,
  suppliers,
  getSuppliers,
  getRoNos,
}) => {
  const dispatch = useDispatch()
  const query = useQuery();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [company, setCompany] = useState(null)
  const [client, setClient] = useState(null)
  const [product, setProduct] = useState(null)
  const [estimate, setEstimate] = useState(null)
  const [state, setStates] = useState(null)
  const [city, setCities] = useState(null)
  const [supplier, setSupplier] = useState(null)
  const [ro, setRO] = useState(null)

  const handleChangeCompanies = (val) => {
    setCompany(val);
    fetchClients(val)
    getSuppliers(val);
    setClient(null)
    setProduct(null)
    setEstimate(null)
    if (query.has('comapny')) {
      query.set('comapny', val)
    } else {
      query.append('comapny', val)
    }
  }

  const handleChangeClients = (val) => {
    if (val) {
      setClient(val)
      fetchProducts(val.value)
      getRoNos(val.code);
    } else {
      setClient(null)
    }
    setProduct(null)
    setEstimate(null)
    setRO(null)
  }

  const handleChangeProducts = (val) => {
    if (val) {
      setProduct(val)
      if (fetchEstimates) {
        fetchEstimates({ companyCode: company, clientId: client.value, productId: val.value })
      }
    } else {
      setProduct(null)
    }
    setEstimate(null)
  }

  const handleChangeEstimates = (val) => {
    if (val) {
      setEstimate(val)
    } else {
      setEstimate(null)
    }
  }

  const handleChangeCity = (val) => {
    if (val) { setCities(val.value) } else { setCities(val) }
  }

  const handleChangeStates = (val) => {
    if (val) {
      setStates(val.value)
      getCities(val.id)
      setCities(null)
    } else {
      setStates(val)
      setCities(null)
    }
  }

  const handleChangeSupplier = (val) => {
    if (val) {
      setSupplier(val)
    } else {
      setSupplier(null)
    }
  }

  const handleChangeRO = (val) => {
    if (val) {
      setRO(val)
    } else {
      setRO(null)
    }
  }

  const generateReport = () => {
    const sd = moment(startDate);
    const ed = moment(endDate);
    if (ed.diff(sd, 'days') < 0) {
      showToast('warning', 'End date should be greater then start date');
      return;
    }

    if (company) {
      if (query.has('company')) {
        query.set('company', company)
      } else {
        query.append('company', company)
      }
    }
    if (client) {
      if (query.has('client')) {
        query.set('client', client.code)
      } else {
        query.append('client', client.code)
      }
    }
    if (product) {
      if (query.has('product')) {
        query.set('product', product.code)
      } else {
        query.append('product', product.code)
      }
    }
    if (estimate) {
      if (query.has('estimate')) {
        query.set('estimate', estimate.value)
      } else {
        query.append('estimate', estimate.value)
      }
    }
    if (state) {
      if (query.has('state')) {
        query.set('state', state)
      } else {
        query.append('state', state)
      }
    }
    if (city) {
      if (query.has('city')) {
        query.set('city', city)
      } else {
        query.append('city', city)
      }
    }
    if (supplier) {
      if (query.has('supplier')) {
        query.set('supplier', supplier.value)
      } else {
        query.append('supplier', supplier.value)
      }
    }
    if (ro) {
      if (query.has('ro')) {
        query.set('ro', ro.value)
      } else {
        query.append('ro', ro.value)
      }
    }
    dispatch(ataFetchReport(sd.format('YYYY-MM-DD'), ed.format('YYYY-MM-DD'), query.toString()))
  }
  useEffect(() => {
    fetchCompanies();
    getStates();
  }, [fetchCompanies, getCities, getStates]);
  return (
    <div style={{ background: '#fff', minHeight: 'calc(100vh - 100px)' }}>
      <ScreenContainer title="ATA Reports" style={{ background: '#fff' }}>
        <div className="row">
          <div className="col-12">
            <span>
              <b>Note :- </b>
              Start Date, End Date, Companies and Clients are mandatory fields to generate report.
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <span className="error">{startDate === undefined ? 'Please select valid date' : ''}</span>
            <br />
            <DayPickerInput
              value={startDate}
              placeholder="Start Date *"
              formatDate={formatDate}
              parseDate={parseDate}
              format="LL"
              onDayChange={(day) => setStartDate(day)}
              dayPickerProps={{
                selectedDays: startDate,
              }}
            />
          </div>
          <div className="col-3">
            <span className="error">{endDate === undefined ? 'Please select valid date' : ''}</span>
            <br />
            <DayPickerInput
              value={endDate}
              formatDate={formatDate}
              parseDate={parseDate}
              format="LL"
              placeholder="End Date *"
              onDayChange={(day) => setEndDate(day)}
              dayPickerProps={{
                selectedDays: endDate,
              }}
            />
          </div>
          <div className="col-4">
            <span />
            <br />
            <CommonSelect label="Companies *" options={companies} handleChange={handleChangeCompanies} />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-4">
            <CommonSearch label="Clients *" disabled={!company || clients.length === 0} value={client} data={clients} onChange={handleChangeClients} />
          </div>
          <div className="col-4">
            <CommonSearch label="Products" disabled={!client || productFilter.length === 0} value={product} data={productFilter} onChange={handleChangeProducts} />
          </div>
          <div className="col-4">
            <CommonSearch label="Estimates" disabled={!product || estimates.length === 0} value={estimate} data={estimates} onChange={handleChangeEstimates} />
          </div>
        </div>
        <br />
        {client
          ? (
            <>
              <div className="row">
                <div className="col-3">
                  <CommonSearch label="Suppliers" value={supplier} data={suppliers} onChange={handleChangeSupplier} />
                </div>
                <div className="col-3">
                  <CommonSearch label="State" value={state} data={states} onChange={handleChangeStates} />
                </div>
                <div className="col-3">
                  <CommonSearch label="City" disabled={!state && cities && cities.length > 0} value={city} data={cities} onChange={handleChangeCity} />
                </div>
                <div className="col-3">
                  <CommonSearch label="RO" value={ro} data={roNos} onChange={handleChangeRO} />
                </div>
              </div>
              <br />
            </>
          )
          : null}
        <div className="row">
          <div className="col-12 mt-10">
            <CommonButton
              disabled={!startDate || !endDate || !company || !client}
              variant="contained"
              color="primary"
              size="small"
              onClick={generateReport}
            >
              Generate Report
            </CommonButton>
          </div>
        </div>
      </ScreenContainer>
    </div>
  )
}

const mapState = (state) => ({
  clients: state.common.clients,
  companies: state.common.companies,
  estimates: state.common.estimates,
  productFilter: state.common.productFilter,
  suppliers: state.common.suppliers,
  ro: state.common.ro,
  cities: state.common.cities,
  states: state.common.states,
});

const mapActions = {
  fetchEstimates: getEstimates,
  fetchCompanies: getCompanies,
  fetchClients: getClientsByCompanyCode,
  fetchProducts: getProductsByClientId,
  getCities: getAllCities,
  getStates: getAllStates,
  getSuppliers: getSuppliersByCompany,
  getRoNos: getROByClient,
};

export default connect(mapState, mapActions)(AtaReports);
